import { Link } from "react-router-dom";
import { Shield, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";

const footerLinks = {
  Product: [
    { label: "Features", href: "/features" },
    { label: "Solutions", href: "/solutions" },
    { label: "Pricing", href: "/pricing" },
    { label: "Roadmap", href: "#" },
  ],
  Company: [
    { label: "About Us", href: "/about" },
    { label: "Blog", href: "#" },
    { label: "Careers", href: "#" },
    { label: "Contact", href: "/contact" },
  ],
  Resources: [
    { label: "Documentation", href: "#" },
    { label: "Help Centre", href: "#" },
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
  ],
};

const socials = [Twitter, Instagram, Linkedin, Youtube];
const socialLabels = ["Twitter", "Instagram", "LinkedIn", "YouTube"];

export default function Footer() {
  return (
    <footer className="bg-ink text-white/40" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 bg-forest rounded-md flex items-center justify-center">
                <Shield className="w-4 h-4 text-white" />
              </div>
              <span
                className="text-base font-semibold text-white"
                style={{ fontFamily: "'Outfit', sans-serif" }}
              >
                NextTackle
              </span>
            </Link>
            <p className="text-sm leading-relaxed mb-6">
              A simple football analytics platform for academies serious about player development.
            </p>
            <div className="flex gap-3">
              {socials.map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={socialLabels[i]}
                  data-testid={`footer-social-${socialLabels[i].toLowerCase()}`}
                  className="w-8 h-8 bg-white/5 hover:bg-forest rounded-full flex items-center justify-center transition-colors"
                >
                  <Icon className="w-3.5 h-3.5 text-white/40 hover:text-white transition-colors" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white/70 font-semibold text-xs mb-4 uppercase tracking-[0.15em]">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/ /g, "-")}`}
                      className="text-sm hover:text-white/70 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs">© 2025 NextTackle. All rights reserved.</p>
          <p className="text-xs">Frankfurt, Germany.</p>
        </div>
      </div>
    </footer>
  );
}
